import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { SharedServices } from '../../../../../../services/shared.services'
import { AuthService } from '../../../../../../services/auth.services'
import { FormBuilder } from '@angular/forms'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import * as $ from 'jquery'

@Component({
    selector: 'app-modal-client-detail-slideshow-face',
    templateUrl: './modal-client-detail-slideshow-face.component.html',
    styleUrls: [
        './modal-client-detail-slideshow-face.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalClientDetailSlideshowFaceComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN: Boolean = true
    option_SlideshowFace: String = 'active'
    TabSlideshowFaceClass: any
    tabName: any = 'face-all'

    arrTabSlideshowFace = [
        { id: 0, name: 'All', nameSave: 'Registration-Face-All' },
        { id: 1, name: 'Front Smile', nameSave: 'Registration-Face-Front-Smile' },
        { id: 2, name: 'Front Normal', nameSave: 'Registration-Face-Front-Normal' },
        { id: 3, name: 'Side Smile', nameSave: 'Registration-Face-Side-Smile' },
        { id: 4, name: 'Side Normal', nameSave: 'Registration-Face-Side-Normal' },
        { id: 5, name: 'Other 1', nameSave: 'Registration-Face-Other-1' },
        { id: 6, name: 'Other 2', nameSave: 'Registration-Face-Other 2' },
    ]
    status: Boolean = false
    arrSlideshowFace: any[] = []
    arrAllFace: any[] = []
    jsonFace: any = {}
    arrShowStatus: any[] = []
    index: any = 0
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any

    option_Slideshow: any = 'hidden'
    senMax: any = 100
    max: any = 0
    valChange: any = 0
    matrixImage: any[] = []
    arrImage: any[] = []
    arrSlideshowTooth
    emitTabName: any = {}
    animationDuration: any = 300
    ValueAssignOneDistance: any = 0
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @ViewChild('imageId') imageId: ElementRef
    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []
    unscrTabName
    unscrIndex
    unscrAllArrClientTop
    getInfoIndex = undefined
    page = 'slideshow'
    unscrPage

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices) {
        this.option_SlideshowFace = 'active'
        this.TabSlideshowFaceClass = 'option_0'
        this.option_Slideshow = 'active'
    }

    ngOnInit() {
        this.unscrTabName = this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
            if (infoTabName != null && infoTabName['tabName'] != undefined) {
                this.tabName = infoTabName['tabName']
            } else {
                this.tabName = 'face-all'
            }
            const tmpStr: String = this.tabName
            if (tmpStr.includes('face')) {
                this.getArrClientTop()
            }
        })
        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })

        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        // this.getValueSlider();
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrTabName)
            this.unscrTabName.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200) / 2
                        this.width = this.height * 3 / 2
                    }
                }
                const _thi = this
                setTimeout(function() {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrSlideshowFace)
                        }
                    })
                }, 10)
            }
        })
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('face')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function() {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrSlideshowFace)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function() {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrSlideshowFace)
                    }
                }
            })
        }, 10)
    }

    getArrClientTop() {
        this.getDataIndex()
        this.getDataShow()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'slideshow') {
                this.index = infoIndex['index']
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('face') && this.arrAllFace.length > 0) {
                    this.max = this.arrAllFace.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.ValueAssignOneDistance * this.index
                    } else {
                        this.valChange = 0
                    }
                    if (this.arrAllFace[this.index] != undefined) {
                        this.jsonFace = this.arrAllFace[this.index]
                        this.initjsonFace(this.arrAllFace[this.index])
                    }
                }
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            const tmpStr: String = this.tabName
            if (arrAll != null && arrAll['slideshow'] != undefined && arrAll['slideshow'].length > 0) {
                if (this.page == 'slideshow') {
                    this.arrAllFace = arrAll['slideshow']
                    this.arrImage = []
                    this.arrShowStatus = []
                    this.matrixImage = []
                    if (tmpStr.includes('face')) {
                        if (this.arrAllFace.length > 0 && this.getInfoIndex) {
                            this.max = this.arrAllFace.length - 1
                            if (this.max > 0) {
                                this.ValueAssignOneDistance = this.senMax / this.max
                                this.valChange = this.ValueAssignOneDistance * this.index
                            } else {
                                this.valChange = 0
                            }
                            if (this.arrAllFace[this.index] != undefined) {
                                this.jsonFace = this.arrAllFace[this.index]
                                this.initjsonFace(this.arrAllFace[this.index])
                            }
                        }
                    }
                }
            } else {
                this.valChange = 0
                this.arrSlideshowFace = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrSlideshowFace)
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    // getValueSlider() {
    //   this.clientTopServices.changeEmittedValueSlider$.subscribe(res => {
    //     if (res != null && res['sliderClientTop'] != undefined) {
    //       this.valChange = res['sliderClientTop'];
    //     }
    //   });
    // }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            if (this.arrAllFace[this.index] != undefined) {
                this.jsonFace = this.arrAllFace[this.index]
                this.initjsonFace(this.jsonFace)
                this.arrSlideshowFace = this.jsonFace[this.tabName]
            }
            this.valChange = assign
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.index = 0
            this.valChange = 0
            if (this.arrAllFace[this.index] != undefined) {
                this.jsonFace = this.arrAllFace[this.index]
                this.initjsonFace(this.jsonFace)
                this.arrSlideshowFace = this.jsonFace[this.tabName]
            }
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined != this.arrSlideshowFace && this.arrSlideshowFace.length > 0) {
                const tmp: any = this.arrSlideshowFace[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    initjsonFace(json) {
        this.jsonFace['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrSlideshowFace(this.jsonFace)
    }

    getArrSlideshowFace(arrTooth) {
        this.arrSlideshowFace = arrTooth[this.tabName]
        this.getShowStatus(this.arrSlideshowFace)
    }

    toggleTabRegistrationFaceItem(id, index, event) {
        this.TabSlideshowFaceClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'face-all'
                break
            case 'option_1':
                this.tabName = 'face-1'
                break
            case 'option_2':
                this.tabName = 'face-2'
                break
            case 'option_3':
                this.tabName = 'face-3'
                break
            case 'option_4':
                this.tabName = 'face-4'
                break
            case 'option_5':
                this.tabName = 'face-5'
                break
            case 'option_6':
                this.tabName = 'face-6'
                break
            default:
                this.tabName = 'face-all'
                break
        }
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.emitTabName['tabName'] = this.tabName
        this.arrSlideshowFace = this.jsonFace[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrSlideshowFace)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
            })
        }
        this.resetMatrixMovedUpPage()
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/slideshow/slideshowFace/modal-client-detail-slideshow-face.component.ts